import React from 'react';

function QuillesSponsorBanner({ banner }) {
	if (!banner) return null;

	return (
		<aside className="quilles-sponsor-banner" aria-label="Partenaire">
			<a
				href={banner.href}
				target="_blank"
				rel="noopener noreferrer"
				className="quilles-sponsor-banner-link"
			>
				<img
					src={banner.image}
					alt={banner.label || 'Partenaire'}
					className="quilles-sponsor-banner-img"
					width={690}
					height={180}
					loading="lazy"
					decoding="async"
				/>
			</a>
		</aside>
	);
}

export default QuillesSponsorBanner;
